import { createFileRoute } from '@tanstack/react-router';

import { ProjectInfo } from '@/components/content/ProjectInfo';

export const Route = createFileRoute('/_map/_sidebar/info')({
  beforeLoad: ({ search }) => {
    const { resultIndex, ...rest } = search as { resultIndex?: number } & Record<string, unknown>;

    return { search: rest };
  },
   
  component: ProjectInfo,
});
